import { postAPI } from "./Networking";

export default class VideoAPI {
  uploadVideo = async (
    files: File[] | null,
    container: string
  ): Promise<string[]> => {
    try {
      if (!files || files.length === 0) {
        throw new Error("No files provided for upload.");
      }

      const formData = new FormData();
      formData.append("container", container);

      files.forEach((file) => {
        formData.append("files", file);
      });

      const response = await postAPI(
        "/v5/images/videos",
        formData
      );

      return response.result as string[];
    } catch (error) {
      throw error;
    }
  };
}
